import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './SimplePage.module.scss';
import {Container, Row, Col} from "react-bootstrap";
import * as pageActions from '../../redux/action/page.action';
import * as functions from "../../helper/functions";
import * as announcementActions from "../../redux/action/announcement.action";

class SimplePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      description: ''
    }
  }

  async componentDidMount() {
    this.getFormInfo();
  }

  async componentWillReceiveProps(nextProps, nextContext) {
    this.getFormInfo();
  }

  async getFormInfo() {
    const paths = functions.getFilterName();
    let response = {};
    if (paths[0] === 'announcement') {
      response = await this.props.fetchAnnouncement(paths[1]);
    } else {
      response = await this.props.fetchPagesByKey(paths[0]);
    }

    this.setState({description: response.description})
  }


  render() {
    return (
        <React.Fragment>
          <Container fluid className={`p-0`}>
            <div className={style.background}>
              <Row className={style.wrapper}>
                <Col md={2} />
                <Col md={8} className={'pt-4 px-5'}>
                  <div className={`${style.property_info}`}>
                    <Container>
                      <Row className={'mb-2 text-center'}>
                        <Col xs={12} className={`d-flex justify-content-center ${style.content}`}>
                          <div className={'quill'} dangerouslySetInnerHTML={{__html: this.state.description}} />
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Col>
                <Col md={2} />
              </Row>
            </div>
          </Container>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  fetchPagesByKey: (key) => dispatch(pageActions.fetchPagesByKey(key)),
  fetchAnnouncement: (id) => dispatch(announcementActions.fetchAnnouncement(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SimplePage));
